import React, { useEffect, useState, useContext, useRef } from 'react'
import PageTitle from '../_general/PageTitle'
import { colors, timings } from 'shared-ui'
import { css } from '@emotion/react'
import TableauAuth from '../tableau/TableauAuth'
import Profile from '../../context/Profile'
import AnalyticsContent from '../tableau/AnalyticsContent'
import LoaderBackground from '../tableau/LoaderBackground'
import Cta from '../_control/Cta'
import { NavLink } from 'react-router'
import { AnalyticsProvider } from "../../context/Analytics"
import { FormattedMessage, useIntl } from 'react-intl'
import PageSubtitle from '../_general/PageSubtitle'
import PdfGeneratorForm from '../pdfGenerator/PdfGeneratorForm'

export default function Analytics({ ...props }) {

    const { data: profile } = useContext(Profile)
    const [authOk, setAuthOk] = useState(false)
    const { formatMessage } = useIntl()

    // force scrollers always on to prevent layout shifts for Tableau
    useEffect(() => {
        const scroller = document.getElementById("pageScroller")
        if (scroller) {
            scroller.style.overflow = '-moz-scrollbars-vertical'
            scroller.style.overflowY = 'scroll'
        }
        return function cleanup() {
            scroller.style.overflow = 'auto'
            scroller.style.overflowY = 'auto'
        }
    }, [])

    // check scrolled status of page with intersect observer
    const phantomRef = useRef()
    const [isScrolled, setIsScrolled] = useState(false)
    useEffect(() => {
        const phantom = phantomRef.current
        const observer = new IntersectionObserver((observerEntries) => {
            const visibleRatio = observerEntries?.[0]?.intersectionRatio
            if (visibleRatio === undefined) return
            setIsScrolled(visibleRatio < 1)
        })
        observer.observe(phantom)
        return () => observer.unobserve(phantom)
    }, [])

    const tabs = ['basic', 'advanced']
    const [selectedTab, setSelectedTab] = useState(tabs[0])

    return (
        <div css={style.wrapper}>
            <script src="https://public.tableau.com/javascripts/api/tableau-2.min.js"></script>
            <div
                ref={phantomRef}
                css={css`position: absolute; height: 1px;`}>
            </div>
            <div css={[
                style.header,
                css`box-shadow: ${isScrolled && '0px 0px 2px 1px rgba(100,100,100,0.35)'};
                    transition: box-shadow ${timings.responsive};`
            ]}>
                <PageTitle css={style.title}>
                    <>
                        <FormattedMessage id='analytics' /> {!authOk && ' / '} {
                            selectedTab === tabs[0] ?
                                formatMessage({ id: 'basic' })
                                : (!authOk && formatMessage({ id: 'advanced' }))
                        }
                    </>
                    {selectedTab === 'basic' &&
                        <Cta css={css`width: min-content; font-size: 0.6em;`}
                            onClick={() => setSelectedTab(tabs[1])}
                        >
                            {formatMessage({ id: 'advanced' })}
                        </Cta>
                    }
                </PageTitle>
                {selectedTab === tabs[1] &&
                    <TableauAuth
                        setAuthOk={setAuthOk}
                        css={[
                            !profile?.admin && authOk === true && css`visibility: hidden;`,
                            css`margin-right: 2em`,
                        ]}
                    />
                }
            </div>

            {selectedTab === tabs[0] &&
                <div css={css`
                    margin: 0em 2em 2em 2em;
                    display: grid;
                    gap: 2em;
                `}>
                    <section css={css`
                        display: grid;
                        gap: 1em;
                    `}>
                        <PageSubtitle>
                            {formatMessage({ id: 'generateReport' })}
                        </PageSubtitle>

                        <PdfGeneratorForm />

                    </section>
                </div>
            }

            {selectedTab === tabs[1] && (
                authOk === true ?
                    <AnalyticsProvider>
                        <AnalyticsContent />
                    </AnalyticsProvider>
                    : !authOk ? <LoaderBackground />
                        : authOk === 'error' ?
                            <div css={style.fallback}>
                                <div>
                                    <FormattedMessage id='noAnalyticsLicenseContactUS'
                                        values={{
                                            p: chunks => <p>{chunks}</p>,
                                            br: () => <br />
                                        }}
                                    />
                                    <NavLink to='/account?contactPrefill=requestAnalytics'>
                                        <Cta css={css`font-size: 0.8em;`}>
                                            <FormattedMessage id='contactUs' />
                                        </Cta>
                                    </NavLink>
                                </div>
                            </div>
                            : null)
            }
        </div>
    )
}

const style = {
    wrapper: css`
        display: flex; 
        flex-direction: column;
        align-items: stretch;
        flex-grow: 1;
        padding: 0; 
    `,
    header: css`
        display: flex; 
        justify-content: 
        space-between; 
        align-items: center;
        position: sticky;
        top: 0;             
        z-index: 1;       
        padding: 1em 2em 1em 2em;
        backdrop-filter: saturate(40%) blur(40px);
        -webkit-backdrop-filter: saturate(40%) blur(40px);
    `,
    fallback: css`
        width: 100%; 
        height: 100%; 
        display: grid; 
        place-items: center;
        padding: 1.5em;
        font-size: 1.2em;
        color: ${colors.soft};

        > div {
            text-align: center;
            padding: 2em;
            border-radius: 5px;
            background: ${colors.substance};
            border: 2px solid ${colors.eventDark};
        }
    `,
    title: css` 
        color: ${colors.main1}; 
        display: flex;
        justify-content: space-between;
        width: 100%;
        aligh-items: center;
        margin: 0;
        @media screen and (max-width: 600px) {
            visibility: hidden;
        }
    `,
}

